import { useFormikContext } from "formik";
import type React from "react";
import { ButtonGroupField } from "../../../components/Forms/ButtonGroup";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent";

interface SftpReceiverIntegrationFormProps {
  namespace: string;
}

export default function SftpReceiverIntegrationForm(
  props: SftpReceiverIntegrationFormProps,
): React.ReactElement {
  const { values } = useFormikContext<Record<string, unknown>>();
  const withNamespace = (field: string) => {
    return `${props.namespace}.${field}`;
  };

  // Get the current auth type from form values
  const integration = values[props.namespace] as
    | { sftpCredentials?: { type?: string } }
    | undefined;
  const authType = integration?.sftpCredentials?.type || "public_key";
  const isBasicAuth = authType === "basic_auth";

  return (
    <>
      <ButtonGroupField
        fieldName={withNamespace("sftpCredentials.type")}
        label={{ label: "Authentication Type" }}
        options={[
          { value: "public_key", label: "SSH Key" },
          { value: "basic_auth", label: "Password" },
        ]}
      />
      {isBasicAuth ? (
        <NewTextFormComponent
          fieldName={withNamespace("sftpCredentials.password")}
          label={{ label: "Password" }}
          type={"password"}
        />
      ) : (
        <NewTextFormComponent
          fieldName={withNamespace("sftpCredentials.publicKey")}
          label={{ label: "Your Public SSH Key" }}
          type={"textarea"}
        />
      )}
    </>
  );
}
